(function (angular) {
    'use strict';

    angular.module('channels.email')

        /**
         *
         */
        .factory('emailSettingsService',
            ['$http', '$q', 'jwtService', 'portalConfig',
                function ($http, $q, jwtService, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    //  urlBase = 'http://localhost:8001';
                    var fac = {
                        getEmailSettings: getEmailSettings,
                        updateEmailSettings: updateEmailSettings,
                        deleteEmailSettings: deleteEmailSettings,
                        getCustomDomain: getCustomDomain
                    };

                    return fac;



                    /**
                     * Method to get Settings for email.
                     * @returns {Promise} A promise that returns settings
                     */
                    function getEmailSettings(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/channels/email")
                            .then(getEmailSettingsComplete)
                            .catch(getEmailSettingsFailed);

                        function getEmailSettingsComplete(response) {
                            return response.data;
                        }

                        function getEmailSettingsFailed(error) {
                            return $q.reject(error);
                        }
                    }

                    function updateEmailSettings(id, updateData) {

                        return $http.put(urlBase + "/apispaces/" + id + "/channels/email", updateData)
                            .then(updateEmailSettingsComplete)
                            .catch(updateEmailSettingsFailed);

                        function updateEmailSettingsComplete(response) {
                            return response.data;
                        }

                        function updateEmailSettingsFailed(error) {
                            console.error("updateEmailSettingsFailed", error);
                            return $q.reject(error);
                        }
                    }

                    function deleteEmailSettings(id) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/channels/email")
                            .then(deleteEmailSettingsComplete)
                            .catch(deleteEmailSettingsFailed);

                        function deleteEmailSettingsComplete(response) {
                            return response.data;
                        }

                        function deleteEmailSettingsFailed(error) {
                            console.error("deleteEmailSettingsFailed", error);
                            return $q.reject(error);
                        }
                    }

                    function getCustomDomain(id, domainName) {

                        // return Promise.resolve({
                        //     "domain": "marta.test1.domain",
                        //     "isConfigured": true,
                        //     "isDefault": false,
                        //     "ips": [
                        //         {
                        //             "ip": "141.193.32.19",
                        //             "type": "shared"
                        //         }
                        //     ]
                        // });

                        return $http.get(urlBase + "/apispaces/" + id + "/channels/email/domains/" + domainName)
                            .then(getCustomDomainComplete)
                            .catch(getCustomDomainFailed);

                        function getCustomDomainComplete(response) {
                            return response.data;
                        }

                        function getCustomDomainFailed(error) {
                            console.error("getCustomDomainFailed", error);
                            return $q.reject(error);
                        }
                    }

                }]);

})(window.angular);
